import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, CustomButton, SubTitle, Title } from "./styles";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";

export const FriendInviteConfirmPopup = () => {
	const { getImage } = useImagePath("cdn");
	const navigate = useNavigate();
	const { close, stack } = usePopUpsV2();
	const scale = useCalculateScale(343 + 40, 465 + 40);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const currentPopup = [...stack]
		.reverse()
		.find(({ variant }) => variant === "friend-invite-confirm-popup");
	const analyticsPayload = {
		event_name: "friend_invitation_sent_dialog",
		event_type: "friend_invitation_sent_dialog",
		source: "web_friend_referral",
		type: currentPopup?.payload?.type as string
	};

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			...analyticsPayload,
			action: "view"
		});
	}, []);

	const onClose = (cs?: boolean) => {
		reportPlaygamiEvent("tp.web_frontend", {
			...analyticsPayload,
			action: cs ? "continue_shopping" : "close"
		});
		close({ variant: "friend-invite-confirm-popup" });
		if (cs) {
			navigate("/shop");
		}
	};

	return (
		<Container
			scale={scale}
			$backgroundImage={getImage(
				friendCenterAssets.common.confirmPopupBackground
			)}
		>
			<CloseIconButton onClose={() => onClose(false)} />
			<div>
				<Title>
					Your invitation
					<br /> has been sent
				</Title>
				<SubTitle>
					Your reward is granted after
					<br /> your friend visits the web.
				</SubTitle>
			</div>
			<CustomButton themeColor="secondary" onClick={() => onClose(true)}>
				Continue Shopping
			</CustomButton>
		</Container>
	);
};
